<ideapa-error-page
  [showBack]="false"
  [type]="'403'"
  [desc]="(error$ | async) || 'Non è possibile accedere alla risorsa richiesta.'"
  [title]="'Accesso negato'"
>
  <div>
    <a (click)="logout()" class="btn btn-primary">Logout</a>
  </div>
</ideapa-error-page>
